import './bootstrap';
import '../css/app.css';

import { createSSRApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import BootstrapVue3 from 'bootstrap-vue-3';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import { router } from '@inertiajs/vue3';
import { createPinia } from 'pinia'

// ✅ Import PostHog utilities
import { initPostHog, identifyUser, trackPageView } from './posthog';

const appName = import.meta.env.VITE_APP_NAME || 'Balan.ai';

// ✅ Delay PostHog Initialization to ensure cookies load
setTimeout(() => {
    initPostHog();
}, 1000);

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createSSRApp({ render: () => h(App, props) });
        app.use(plugin).use(ZiggyVue).use(BootstrapVue3);
        
        const pinia = createPinia()
        app.use(pinia)

        if (props.initialPage.props.auth?.user) {
            identifyUser(props.initialPage.props.auth.user);
        }

        // ✅ Track navigation events manually for Inertia.js
        router.on('navigate', () => {
            trackPageView();
        });

        app.mount(el);
    },
    progress: { color: '#4B5563' },
});